import React from 'react';

interface IHeaderContext {
  showHeader(): void;
  hideHeader(): void;
}
export const HeaderContext = React.createContext<IHeaderContext>(null);
